import { addDisplayedEnum } from './enumCommon.js';

const InvestmentAccountType = addDisplayedEnum(
  {
    TRADITIONAL: 'traditional',
    ROTH: 'roth',
  },
  'InvestmentAccountType',
);

const InvestmentAccountStatus = addDisplayedEnum(
  {
    ONBOARDING: 'onboarding',
    SUBMITTED: 'submitted',
    PROCESSING: 'processing',
    ACTIVE: 'active',
  },
  'InvestmentAccountStatus',
);

export { InvestmentAccountType, InvestmentAccountStatus };
